import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const ExitIntentContext = createContext(null);

export const useExitIntent = () => {
  const context = useContext(ExitIntentContext);
  if (!context) {
    throw new Error("useExitIntent must be used within an ExitIntentProvider");
  }
  return context;
};

export const ExitIntentProvider = ({ children }) => {
  const [hasUnsavedWork, setHasUnsavedWork] = useState(false);

  // Allow components to mark that there's unsaved work
  const markUnsavedWork = useCallback((unsaved = true) => {
    setHasUnsavedWork(unsaved);
  }, []);

  // Reset state (e.g., after form submission)
  const resetExitIntent = useCallback(() => {
    setHasUnsavedWork(false);
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleBeforeUnload = (event) => {
      if (hasUnsavedWork) {
        event.preventDefault();
        // Modern browsers ignore custom messages but require returnValue to be set
        event.returnValue = "";
        return "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasUnsavedWork]);

  return (
    <ExitIntentContext.Provider
      value={{
        markUnsavedWork,
        resetExitIntent,
        hasUnsavedWork,
      }}
    >
      {children}
    </ExitIntentContext.Provider>
  );
};